/*
Code for the Careers Page
*/

import React, { useState } from "react";
import { Container, Modal, Button } from "react-bootstrap";
import { Header } from "./Header";
import { Footer } from "./Footer";
import background from "./images/denison_back.jpg";
import {
  FaBuilding,
  FaHeartbeat,
  FaChartLine,
  FaLaptopCode,
  FaLeaf,
  FaCalendarAlt,
  FaLinkedin,
  FaHandshake,
} from "react-icons/fa";

export const Careers = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedCareer, setSelectedCareer] = useState(null);

  const careerData = {
    finance: {
      title: "Finance",
      description:
        "Use financial data to compile market data, predict stock prices, and compile company figures.",
      careers: [
        "Company Analyst",
        "Market Analyst",
        "Investment Banker",
        "Equity Researcher",
      ],
    },
    medicine: {
      title: "Medicine",
      description:
        "Use medical data to analyze health records, track the spread of diseases, and predict a patient's health record over time.",
      careers: [
        "Medical Statistician",
        "Pharmaceutical Developer",
        "Insurance Analyst",
        "Epidemiologist",
      ],
    },
    marketing: {
      title: "Marketing",
      description:
        "Use metrics to analyze and predict market trends, compile consumer data, and create better user experiences.",
      careers: [
        "Growth Marketer",
        "Conversion Rate Optimization Specialist",
        "Search Engine Optimization Specialist",
        "Marketing Data Analyst",
      ],
    },
    computerScience: {
      title: "Computer Science",
      description:
        "Use machine learning to create algorithms, work in software development and help digital infrastructure become more equitable.",
      careers: [
        "Data Engineer",
        "Machine Learning Specialist",
        "Database Administrator",
        "Project Manager",
      ],
    },
  };

  const handleCareerClick = (career) => {
    setSelectedCareer(career);
    setShowModal(true);
  };

  return (
    <div>
      <Header />
      <div className="page-header">
        <img className="header-img" src={background} alt="background" />
        <h1 className="header-img-caption">Careers</h1>
        <p className="header-img-text">
          Data science can be applied to any career. Here are a few example
          paths.
        </p>
      </div>

      <section
        className="networking-section"
        style={{ backgroundColor: "#0D8863", padding: "2rem 0" }}
      >
        <Container>
          <div style={{ textAlign: "left" }}>
            <h2
              className="text-white careers-title"
              style={{ textAlign: "left" }}
            >
              Careers in Data Science
            </h2>
            <p className="text-white">
              Data Science can be applied to any career. Here are a few example
              paths.
            </p>
            <p className="text-white">
              Please click the icons for more information!
            </p>
          </div>
        </Container>
      </section>
      <Container className="my-5">
        <div className="career-grid">
          {Object.entries(careerData).map(([key, career]) => (
            <div
              key={key}
              className="career-card"
              onClick={() => handleCareerClick(career)}
              style={{ cursor: "pointer" }}
            >
              {key === "finance" && <FaBuilding size={40} />}
              {key === "medicine" && <FaHeartbeat size={40} />}
              {key === "marketing" && <FaChartLine size={40} />}
              {key === "computerScience" && <FaLaptopCode size={40} />}
              <p>{career.title}</p>
            </div>
          ))}
        </div>
      </Container>
      <section
        className="networking-section"
        style={{ backgroundColor: "#0D8863", padding: "2rem 0" }}
      >
        <Container>
          <div style={{ textAlign: "right" }}>
            <h2
              className="text-white careers-title"
              style={{ textAlign: "right" }}
            >
              Networking
            </h2>
            <p className="text-white">
              Scripps College offers students a tightly-knit web of connections
              during and after a Scripps education.
            </p>
            <p className="text-white">
              Please click the icons for more information!
            </p>
          </div>
        </Container>
      </section>
      <section>
        <Container>
          <div className="networking-options mt-4">
            <div className="network-item">
              <a
                href="https://olivegrove.scrippscollege.edu/v2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLeaf size={40} className="network-icon" />
              </a>
              <p>
                Create an account on Scripps Olive Grove to connect with alumni
                for internship opportunities or coaching.
              </p>
            </div>

            <div className="network-item">
              <a
                href="https://joinhandshake.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaCalendarAlt size={40} className="network-icon" />
              </a>
              <p>
                Attend online and in-person networking events at the 5Cs. Make
                sure to connect with the people you meet after the event.
              </p>
            </div>

            <div className="network-item">
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin size={40} className="network-icon" />
              </a>
              <p>
                Connect with alumni and alumni-run firms on LinkedIn. You can
                also join affinity groups in the industries you want to learn
                more about.
              </p>
            </div>

            <div className="network-item">
              <a
                href="https://www.scrippscollege.edu/student-services/career-planning-resources"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaHandshake size={40} className="network-icon" />
              </a>
              <p>
                Reach out to connections and ask for an informational interview.
                Stay updated with campus-wide career emails, and make sure to
                schedule an appointment with the Career Planning & Resources
                office.
              </p>
            </div>
          </div>
        </Container>
      </section>
      <Container className="mt-5 mb-5">
        <div className="d-flex justify-content-center gap-3">
          <Button
            href="https://www.linkedin.com/groups/2840579/"
            className="linked-button"
            target="_blank"
          >
            Scripps alumni LinkedIn group
          </Button>
          <Button
            href="https://whatcanidowiththismajor.com/major/data-science/"
            className="linked-button"
            target="_blank"
          >
            What can I do with my major?
          </Button>
          <Button
            href="https://www.scrippscollege.edu/student-services/career-planning-resources"
            className="linked-button"
            target="_blank"
          >
            Scripps Career Services Office
          </Button>
        </div>
      </Container>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        dialogClassName="modal-90w"
      >
        <Modal.Header
          closeButton
          className="modal-header"
        >
          <Modal.Title style={{ color: "black" }}>
            {selectedCareer?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#a5d6c5" }}>
          <p>{selectedCareer?.description}</p>
          <h5>Career Ideas:</h5>
          <ul>
            {selectedCareer?.careers.map((career, index) => (
              <li key={index}>{career}</li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>
      <Footer />
    </div>
  );
};
